exports.components = {
  "component---src-components-project-detail-project-detail-js": () => import("./../../../src/components/ProjectDetail/ProjectDetail.js" /* webpackChunkName: "component---src-components-project-detail-project-detail-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

